"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEvent = generateEvent;
function generateEvent(eventName, source, userEditor, target, changeSet) {
    const detail = {
        eventName: eventName,
        source: source,
        target: null,
        userEditor: null,
        changeSet: null
    };
    if (target) {
        detail.target = target;
    }
    if (userEditor) {
        detail.userEditor = userEditor;
    }
    if (changeSet) {
        detail.changeSet = changeSet;
    }
    global.dispatchEvent(new CustomEvent(eventName, { detail }));
}
//# sourceMappingURL=EventHelper.js.map